module.exports = __webpack_public_path__ + "static/media/diploma.64c4d85b.svg";